function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.516.604L3.3 3.824 1.487 2.01.5 3l2.8 2.8 4.206-4.206-.99-.99z",
  fill: "#fff"
});

var SvgIconLabelDone = function SvgIconLabelDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 6",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOCA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNOS41MTU4IDQuNjAzODhMNi4zIDcuODIzODhMNC40ODcgNi4wMTAxOEwzLjUgNi45OTk5OEw2LjMgOS43OTk5OEwxMC41MDYzIDUuNTkzNjhMOS41MTU4IDQuNjAzODhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMyAtNCkiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgIconLabelDone as ReactComponent };